import React from "react";
import {Link} from 'react-router-dom';
import {useSelector} from "react-redux";
import {Button} from "react-bootstrap";
import ClockWhite from "../../../icons/clock-white.svg";
import Clock from "../../../icons/clock.svg";
import { useTranslation } from 'react-i18next';
import {translateRecord} from "../utils";

const CommonOrder = (props) => {
  const storeAuth = useSelector(store => store.auth);
  const { t } = useTranslation();

  const statuses = {
    created: {color: 'btn-danger', name: t('orderStatuses.created')},
    payed: {color: 'btn-primary', name: t('orderStatuses.payed')},
    cooking: {color: 'btn-info', name: t('orderStatuses.cooking')},
    ready: {color: 'btn-success', name: t('orderStatuses.ready')},
    on_delivery: {color: 'btn-warning', name: t('orderStatuses.on_delivery')},
    completed: {color: 'btn-dark', name: t('orderStatuses.completed')},
    declined_by_restaurant: {color: 'btn-secondary', name: t('orderStatuses.declined_by_restaurant')},
    declined_by_user: {color: 'btn-secondary', name: t('orderStatuses.declined_by_restaurant')},
    refunded: {color: 'btn-light', name: t('orderStatuses.refunded')},
    took: {color: 'btn-info', name: t('orderStatuses.took')},
    waiting: {color: 'btn-success', name: t('orderStatuses.waiting')},
    riding: {color: 'btn-warning', name: t('orderStatuses.on_delivery')},
    canceled: {color: 'btn-secondary', name: t('orderStatuses.declined_by_restaurant')},
  };

  function orderType(order) {
    if (order.ride) {
      return {name: 'Таксі'}
    } else {
      const types = {
        to_go: {color: 'btn-warning', name: t('orderTypes.to_go.name')},
        to_visit: {color: 'btn-primary', name: t('orderTypes.to_visit.name')},
        on_table: {color: 'btn-info', name: t('orderTypes.on_table.name')},
        delivery: {color: 'btn-success', name: t('orderTypes.delivery.name')}
      };
      return types[order.kind]
    }
  }

  function orderTime(order) {
    const myDate = new Date((order.time || order.created_at) + (order.ride ? 0 : (60000 * order.delay)));
    const date = myDate.toJSON().slice(0, 10).split('-').reverse().join('.');
    const minutes = myDate.getMinutes();
    const hours = myDate.getHours();
    return `${date} ${hours}:${minutes < 10 ? `0${minutes}` : minutes}`
  }

  function orderStatuses(order) {
    if (order.status === 'payed' && order.payment_type === 'after_pay') {
      return statuses['created']
    } else {
      return statuses[order.status]
    }
  }

  function orderTypeImg(order) {
    if (order.kind === 'delivery') {
      return String.fromCodePoint('0x1F696');
    } else if (order.kind === 'to_go') {
      return String.fromCodePoint('0x1F961');
    } else if (order.kind === 'to_visit') {
      return String.fromCodePoint('0x1F37D');
    } else if (order.ride) {
      return String.fromCodePoint('0x1F695');
    } else {
      return String.fromCodePoint('0x1F374');
    }
  }

  const order = () => {
    return (
      <div className='order-header'>
        <span className={`d-flex align-items-center`}
          style={{position: 'relative', color: storeAuth.auth.userData.theme === 'dark' ? 'white' : '#484645', minWidth: '97px'}}
        >
          <span className='emoji mr-2 p-0' role="img" aria-label={'label'}>
            {orderTypeImg(props.order)}
          </span>
          <div className='text-center'>
            <span><strong>{orderType(props.order).name}</strong></span>
            <span className='d-block'>{props.order.id}</span>
          </div>
        </span>
        <span style={{color: storeAuth.auth.userData.theme === 'dark' ? 'white' : '#484645'}} className='text-center d-block'>
          { !!props.order.restaurant && !props.doNotShowRestaurant &&
            <span style={{display: 'block'}}>
              <strong>{translateRecord(props.order.restaurant, 'name')}</strong>
            </span>}
          { props.order.status !== 'completed' &&
            <Button className={`btn-xxs ${orderStatuses(props.order).color}`}>
              <span className={`${props.order.status === 'declined_by_restaurant' && 'red-notice'}`}>
                {orderStatuses(props.order).name}
              </span>
            </Button>}
        </span>
        { new Date().toDateString() === new Date(props.order.time || props.order.created_at).toDateString() ?
          <span className='d-block text-right' style={{minWidth: '73px'}}>
            { orderTime(props.order).length > 0 &&
              <span className='d-flex align-items-center justify-content-end mb-1'>
                <img src={storeAuth.auth.userData.theme === 'dark' ? ClockWhite : Clock} style={{height: '14px'}}
                     className='mr-1'/>
                <span style={{color: storeAuth.auth.userData.theme === 'dark' ? 'white' : '#484645'}}>
                  {orderTime(props.order).split(' ')[1]}
                </span>
              </span>}
            <span className='dish-price'>
              <b>{props.order[props.field] || props.order.amount || props.order.price}</b><small>₴</small>
            </span>
          </span>
        :
          <span style={{color: storeAuth.auth.userData.theme === 'dark' ? 'white' : '#484645', minWidth: '73px'}}
                className='text-right d-block'
          >
            <span className='d-block'>{orderTime(props.order).split(' ')[0]}</span>
            <span className='d-block dish-price'>
              <b>{props.order[props.field] || props.order.amount || props.order.price}</b><small>₴</small>
            </span>
          </span>}
      </div>)
  };

  return (
    <div className='order'>
      { !!props.link ?
        <Link to={`/${props.order.ride ? 'driver_ride' : props.link}/${props.order.id}${!!props.order.shared ? `?share_token=${props.order.share_token}` : ''}`}>
          {order()}
        </Link>
      :
        order()
      }
    </div>
  );
};

export default CommonOrder;
